import type { ChangeEvent } from 'react';
import { digitsOnly } from '../../../helpers/formatters';
import MaskedInput from '../../../helpers/text-mask';
import { conformToMask } from '../../../helpers/text-mask/conformToMask';
import type { MaskConfig } from './mask-types';
import type { InputProps } from './types';
import { getMaskConfigProps } from './utils';

const phoneMasks = {
  hyphenated: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  standard: ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
};

const phonePatterns = {
  hyphenated: '[0-9]{3}-[0-9]{3}-[0-9]{4}',
  standard: '\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}',
};

export const PhoneInput = ({
  format = 'standard',
  onChange,
  value = '',
  ...rest
}: InputProps<'phone'> & MaskConfig) => {
  // always keep the value digits-only, keeping formatting only in the ui
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ name: rest.name, value: digitsOnly(event.target.value) });
  };

  const { maskConfigProps, nonConfigProps } = getMaskConfigProps(rest);

  return (
    <MaskedInput
      {...nonConfigProps}
      onChange={handleChange}
      type='tel'
      pattern={phonePatterns[format]}
      mask={phoneMasks[format]}
      value={value.trim() ? conformToMask(value, phoneMasks[format], maskConfigProps).conformedValue : value}
    />
  );
};
